import { render, staticRenderFns } from "./RestartReq.vue?vue&type=template&id=b1a071f6&"
import script from "./RestartReq.vue?vue&type=script&lang=js&"
export * from "./RestartReq.vue?vue&type=script&lang=js&"
import style0 from "./RestartReq.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports